import usePublishExamination from './usePublishExamination';

export default usePublishExamination;
